module.exports = __webpack_public_path__ + "d522c60daeed2caa8f2f65d4a9750ff8.svg";